import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'partnerSatSecrets',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPartnerSatSecrets: builder.query({
      query: ({ satClientId }) => {
        return ({
          url: `/sat_clients/${satClientId}/sat_secrets`,
        })
      },
      providesTags: (result) => [{ type: 'partnerSatSecrets', id: 'LIST' }],
    }),

    createPartnerSatSecret: builder.mutation({
      query: ({ satClientId, justification }) => {
        return ({
          url: `/sat_clients/${satClientId}/sat_secrets`,
          method: 'POST',
          body: {
            ...(!!justification && { audit_comment: justification }),
          },
        })
      },
      invalidatesTags: ['partnerSatSecrets'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchPartnerSatSecretsQuery,
  useCreatePartnerSatSecretMutation,
} = extendedApi
